<main @fade>
  <nb-card [nbSpinner]="loading">
    <nb-card-header *ngIf="!isModal && editMode === false" i18n="@@Creating"><a
      [routerLink]="absolutePath">{{ title }}</a> / Добавление
    </nb-card-header>
    <nb-card-header *ngIf="!isModal && editMode === true" i18n="@@Updating">
    </nb-card-header>
    <nb-card-header *ngIf="!isModal && editMode === true" i18n="@@Updating"></nb-card-header>

    <nb-card-header *ngIf="deleted">
      <span i18n="@@RecordDeletedNoTags" class="badge badge-secondary">запись удалена</span>
      <button
        *ngIf="deleted"
        (click)="restore()"
        i18n-nbTooltip="@@Restore"
        nbTooltip="восстановить"
        nbButton

      >
        <nb-icon icon="repeat-outline"></nb-icon>
      </button>
    </nb-card-header>
    <nb-card-body>
      <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <formly-form
          [form]="form"
          [fields]="fields"
          [options]="options"
          [model]="model"
        ></formly-form>
        <div *ngIf="shareUrl!=''">
          <a
            nbTooltip="Скопировать"
            i18n-nbTooltip="@@Copy"
            style="cursor:pointer"
            (click)="copyShareUrl(shareUrl)"
          >
            <nb-icon icon="copy-outline"></nb-icon>
            {{ shareUrl }}
          </a>
        </div>
        <button nbButton status="primary" type="submit" [disabled]="!form.valid" i18n>
          Сохранить
        </button>
        &nbsp;
        <button *ngIf="isModal" (click)="modalClose()" nbButton status="basic" type="button"
                i18n="@@Close">Закрыть
        </button>
        <!--          <button-->
        <!--            nbButton-->
        <!--            status="primary"-->
        <!--            type="submit"-->
        <!--            class="btn btn-brand"-->
        <!--            [disabled]="!form.valid"-->
        <!--            i18n-->
        <!--          >-->
        <!--            Сохранить-->
        <!--          </button>-->
      </form>
    </nb-card-body>
  </nb-card>
</main>
